import React from "react";
import { Money, MoneyFormat, MoneyType } from "~/components/Money";
import { CurrencyCode } from "~/graphql/supergraphEnums";
import { type ExtensionFieldValueObjectType } from "~/graphql/supergraphTypes";
import { EmptyValueRenderer } from "./EmptyValueRenderer";
import * as styles from "./styles_vanilla.css";

interface CurrencyFieldRendererProps {
  value: ExtensionFieldValueObjectType;
}

/**
 * Cell renderer for currency (USD) extension fields
 * Displays currency values with proper USD formatting using the shared Money component
 * Follows the same patterns as MoneyCellRenderer for consistency
 */
export const CurrencyFieldRenderer: React.FC<CurrencyFieldRendererProps> = ({ value }) => {
  const currencyValue = value.floatValue;

  if (currencyValue === null || currencyValue === undefined) {
    return <EmptyValueRenderer />;
  }

  // Convert to Money format (amount in cents) with proper rounding
  const money: MoneyType = {
    amount: Math.round(currencyValue * 100),
    currency: CurrencyCode.Usd,
    precision: 2,
  };

  return (
    <span className={styles.currencyValue} title={`$${currencyValue.toFixed(2)}`}>
      <Money money={money} format={MoneyFormat.Symbol} rounded={false} dashesAsDefault />
    </span>
  );
};
